export const DETAILS = 'Подробности';
export const ROLLUP = 'Свернуть';
export const OPEN = 'Текущий';
export const WORKING = 'В работе';
export const CLOSED = 'Завершен';
export const REJECTED = 'Отклонен';
export const UNKNOWN = 'Не определен';



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/requestcard/consts.ts